import { css } from '@emotion/react';
import { Button, RadioButton, spacing } from '@uniquegood/realworld-studio-design';
import { MarginTop8 } from '@/styles';
import { templateItemRadioButton, TemplateItemStyle } from './styles';

type TemplateItemProps = Pick<ProjectTemplateResponseModel, 'id' | 'name' | 'imageUrl'> & {
  onChange(value?: string): void;
  checked: boolean;
  onDetailClick: () => void;
  radioButtonDisabled?: boolean;
};

export function TemplateItem({
  id,
  name,
  imageUrl,
  onChange,
  checked,
  onDetailClick,
  radioButtonDisabled = false
}: TemplateItemProps) {
  return (
    <div css={[TemplateItemStyle]}>
      <div
        css={[
          templateItemThumbnail,
          {
            backgroundImage: `url(${imageUrl})`
          }
        ]}
      >
        <div className="hover">
          <Button type="primary" size="small" onClick={onDetailClick}>
            자세히 보기
          </Button>
        </div>
      </div>
      <RadioButton
        name="selected-template"
        value={id ?? ''}
        onChange={onChange}
        checked={checked}
        cssStyle={[MarginTop8, templateItemRadioButton]}
        disabled={radioButtonDisabled}
      >
        {name}
      </RadioButton>
    </div>
  );
}

export const templateItemThumbnail = css`
  display: grid;
  place-items: center;
  position: relative;

  width: 173px;
  height: 138px;

  background-color: #c4c4c4;
  background-position: center;
  background-size: cover;

  border-radius: ${spacing.borderRadius.xlarge};
  overflow: hidden; // border-radius 적용 목적

  /* 어두운 오버레이 - hover 시 나타남 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7); // 어두운 오버레이
    opacity: 0;
    z-index: 2; // PlanBadge(z-index: 1) 위에 위치
    transition: opacity 0.2s ease; // 부드러운 전환
  }

  &:hover::before,
  &:focus-visible::before {
    opacity: 1; // hover 시 보임
  }

  .hover {
    display: none;
    z-index: 3;
  }

  :hover > .hover,
  :focus-visible > .hover {
    display: grid;
    place-content: center;
  }

  padding: 0 ${spacing.padding.large};
`;
